<wbo-edit-page #editPage [title]="model.data.name" (addingAnother)="addingAnother($event)">
    <wbo-entity-actions>
        <wbo-entity-action
            [title]="'wbo.product-line.edit.actions.downloadRecipeCard'"
            (click)="downloadRecipeCard()"></wbo-entity-action>
    </wbo-entity-actions>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.productDetails', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name"
                                                   [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <fui-column>
                                <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                                      [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                                <wbo-checkbox-edit-control formControlName="mgtOnly"
                                                           [(ngModel)]="model.data.mgtOnly"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-append-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <ng-container formGroupName="primaryCategory">
                                <wbo-category-single-select-edit-control formControlName="categoryId"
                                                                         [(ngModel)]="model.data.primaryCategory.categoryId"
                                                                         [objectValue]="model.data.primaryCategory">
                                </wbo-category-single-select-edit-control>
                            </ng-container>
                            <wbo-text-edit-control formControlName="plu"
                                                   [(ngModel)]="model.data.plu"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.description">
                        </wbo-textarea-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="externalDescription"
                                                   [(ngModel)]="model.data.externalDescription">
                        </wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-currency-edit-control formControlName="price"
                                                       [(ngModel)]="model.data.price"></wbo-currency-edit-control>
                            <wbo-currency-edit-control formControlName="baseCostEx"
                                                       [(ngModel)]="model.data.baseCostEx"></wbo-currency-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-dietary-indicator-multi-select-edit-control [(ngModel)]="model.data.dietaryIndicators"
                                                                             [multiObjectValueType]="true"
                                                                             formControlName="dietaryIndicators">
                            </wbo-dietary-indicator-multi-select-edit-control>
                            <wbo-numeric-edit-control formControlName="kiloJoules"
                                                      [notation]="'kJ'"
                                                      [(ngModel)]="model.data.kiloJoules"></wbo-numeric-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-tax-multi-select-edit-control formControlName="taxes" [multiObjectValueType]="true"
                                                               [(ngModel)]="model.data.taxes">
                            </wbo-tax-multi-select-edit-control>
                            <wbo-single-select-edit-control formControlName="applyMinimumAge" [(ngModel)]="model.data.applyMinimumAge"
                                                            [clearSelectionOptionLabel]="'wbo.product-line.edit.field.applyMinimumAge.placeholder'">
                                <wbo-select-options>
                                    <wbo-select-option [label]="'wbo.product-line.edit.option.applyMinimumAge.yes'"
                                                       [value]="true"></wbo-select-option>
                                    <wbo-select-option [label]="'wbo.product-line.edit.option.applyMinimumAge.no'"
                                                       [value]="false">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column formGroupName="customObjectContext">
                        <wbo-custom-object-multi-select-edit-control formControlName="customObjects"
                                                                     [productLineContext]="true"
                                                                     [(ngModel)]="model.data.customObjectContext.customObjects">
                        </wbo-custom-object-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-text-edit-control formControlName="receiptText"
                                           [(ngModel)]="model.data.receiptText"></wbo-text-edit-control>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.images', formControlNames: ['productImage', 'icon']}">
        <wbo-sellable-edit-imagery></wbo-sellable-edit-imagery>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.priceLevels', formControlNames: 'priceLevels'}">
        <wbo-sellable-edit-price-levels [showScaleFields]="true"></wbo-sellable-edit-price-levels>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.extras', formControlNames: 'extras'}">
        <fui-rows>
            <fui-row>
                <fui-two-columns [formGroup]="editPage.formGroup">
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="popup"
                                                   [(ngModel)]="model.data.popup"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.extras" [editable]="false" [removable]="true"
                                   [entityPath]="'extras'" [localisable]="true" [reorderable]="true"
                                   [showHeader]="false">
                        <wbo-edit-link-column field="name" [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                        <wbo-edit-grid-add-row [identifierField]="'id'" [assignLocalisation]="true" (onAfterEntityAdded)="afterExtraAdded($event)">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-extra-single-select-edit-control></wbo-extra-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search
                                    [searchComponent]="ExtraSearchPageComponent"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [editPath]="'extra'"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.orderingAndPreparation', formControlNames: 'tags'}">
        <fui-rows>
            <fui-row>
                <fui-two-columns [formGroup]="editPage.formGroup">
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="popup"
                                                   [(ngModel)]="model.data.popup"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-sellable-edit-barcodes [title]="'wbo.product-line.edit.field-set.barcodes'"></wbo-sellable-edit-barcodes>
            </fui-row>
            <fui-row [label]="'wbo.product-line.edit.field-set.dockets'">
                <fui-two-columns [formGroup]="editPage.formGroup">
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-text-edit-control formControlName="kitchenText"
                                                   [(ngModel)]="model.data.kitchenText"></wbo-text-edit-control>
                            <wbo-text-edit-control formControlName="foreignKitchenText"
                                                   [(ngModel)]="model.data.foreignKitchenText"></wbo-text-edit-control>
                        </fui-tandem-field>
                        <wbo-edit-grid [data]="docketSelectors" [editable]="false" [removable]="true" [entityPath]="'tags'"
                                       (removed)="metaTagRemoved($event)" [showHeader]="false"
                                       [title]="'wbo.product-line.edit.field-set.docketSelectors'">
                            <wbo-edit-link-column field="name"
                                                  [editComponent]="DocketSelectorEditPageComponent"
                                                  [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                            <wbo-edit-grid-add-row [customAdd]="true" (onSearchSelect)="selectMetaTag($event)"
                                                   (onNewSelect)="selectMetaTag([$event])">
                                <wbo-edit-grid-add-row-quick-add>
                                    <wbo-meta-tag-single-select-edit-control [type]="MetaTagType.DOCKET_SELECTOR"></wbo-meta-tag-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search [searchComponent]="DocketSelectorSearchPageComponent"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity [editComponent]="DocketSelectorEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="printPriority"
                                                      [(ngModel)]="model.data.printPriority"></wbo-numeric-edit-control>
                            <wbo-single-select-edit-control formControlName="styleType"
                                                            [(ngModel)]="model.data.styleType">
                                <wbo-select-options>
                                    <wbo-select-option [value]="1"
                                                       label="wbo.product-line.edit.option.styleType.standard">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="2"
                                                       label="wbo.product-line.edit.option.styleType.alternate">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-edit-grid [data]="preparationModifiers" [editable]="false" [removable]="true" [entityPath]="'tags'"
                                       [reorderable]="true" [showHeader]="false"
                                       [localisable]="true" (removed)="metaTagRemoved($event)"
                                       (reordering)="preparationModifierReordering($event)"
                                       [title]="'wbo.product-line.edit.field-set.preparationModifiers'">
                            <wbo-edit-link-column field="name" [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                            <wbo-edit-grid-add-row [customAdd]="true" (onSearchSelect)="selectMetaTag($event)"
                                                   (onNewSelect)="selectMetaTag([$event])">
                                <wbo-edit-grid-add-row-quick-add>
                                    <wbo-meta-tag-single-select-edit-control [type]="MetaTagType.PREPARATION"></wbo-meta-tag-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search [searchComponent]="PreparationModifierSearchPageComponent"
                                                                  [searchParams]="{type: MetaTagType.PREPARATION}"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity [editComponent]="PreparationModifierEditPageComponent"
                                                                      [editParams]="{type: MetaTagType.PREPARATION}"></wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.preparationResourceTypes" [editable]="false" [removable]="true"
                                       [entityPath]="'preparationResourceTypes'"
                                       [title]="'wbo.product-line.edit.field-set.preparationResourceTypes'">
                            <wbo-edit-link-column field="name" [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                            <wbo-numeric-column field="preparationTime" format="1.0-0"></wbo-numeric-column>
                            <wbo-edit-grid-add-row [identifierField]="'id'">
                                <wbo-edit-grid-add-row-quick-add>
                                    <wbo-preparation-resource-type-single-select-edit-control></wbo-preparation-resource-type-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search [searchComponent]="PreparationResourceTypeSearchPageComponent"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity [editComponent]="PreparationResourceTypeEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.productInventory', formControlNames: ['productInventory', 'productInventory.items']}">
        <fui-rows>
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.productInventory.items" [editable]="true" [removable]="true"
                                   [entityPath]="'productInventory.items'" (saved)="inventoryChanged()">
                        <wbo-edit-link-column field="inventory.name" componentPath="inventory"
                                              [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                        <wbo-numeric-column field="amount" format="1.0-3" [editable]="true"></wbo-numeric-column>
                        <wbo-inventory-stock-size-single-select-column field="stockSize" [editable]="true"
                                                                       [inventoryIdField]="'inventory.inventoryId'"></wbo-inventory-stock-size-single-select-column>
                        <wbo-currency-column field="cost" [width]="200">
                            <ng-template headerTemplate>
                                <wbo-stock-costing-header
                                    [(costingType)]="inventoryCostingType" [(outletId)]="inventoryCostingOutletId"
                                    (detailsChange)="costStock()"></wbo-stock-costing-header>
                            </ng-template>
                            <ng-template footerTemplate>
                                <div class="currency">{{totalCost | wbo_currency}}</div>
                            </ng-template>
                        </wbo-currency-column>
                        <wbo-edit-grid-add-row [identifierField]="'inventoryId'" [componentPath]="'inventory'">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-inventory-single-select-edit-control></wbo-inventory-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search
                                    [searchComponent]="InventorySearchPageComponent"
                                    [searchParams]="{filterNonStockable : false}"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [editComponent]="InventoryEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            visible: Plugin.LOYALTY | booleanConfig,
            title: 'wbo.product-line.edit.formation.memberLoyalty',
            formControlNames: 'memberLoyalty'
        }">
        <fui-rows>
            <fui-row>
                <fui-columns>
                    <fui-column>
                        <wbo-edit-grid [data]="loyaltySpecData" [editable]="true"
                                       [entityPath]="'memberLoyalty.memberTypeSpecs'"
                                       (saved)="memberLoyaltySaved($event)">
                            <wbo-column field="membershipType.name">
                                <ng-template cellTemplate let-dataItem="dataItem">
                                    <ng-container *ngIf="dataItem.membershipType.membershipTypeId != undefined">
                                        <wbo-edit-link [dataItem]="dataItem" field="membershipType.name"
                                                       [editComponent]="MembershipTypeEditPageComponent"
                                                       componentPath="membershipType"
                                                       [editMode]="EditMode.VIEW"></wbo-edit-link>
                                    </ng-container>
                                    <ng-container *ngIf="dataItem.membershipType.membershipTypeId == undefined">
                                        {{'wbo.product-line.edit.label.memberLoyalty.productDefaults' | translate}}
                                    </ng-container>
                                </ng-template>
                            </wbo-column>
                            <wbo-member-loyalty-accrual-type-single-select-column field="accrual.type"
                                                                                  membershipTypeField="membershipType"
                                                                                  [editable]="true">
                            </wbo-member-loyalty-accrual-type-single-select-column>
                            <wbo-numeric-column field="accrual.value" [editable]="true">
                            </wbo-numeric-column>
                            <wbo-member-loyalty-redemption-type-single-select-column field="redemption.type"
                                                                                     membershipTypeField="membershipType"
                                                                                     [editable]="true">
                            </wbo-member-loyalty-redemption-type-single-select-column>
                            <wbo-numeric-column field="redemption.value" [editable]="true">
                            </wbo-numeric-column>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns [formGroup]="editPage.formGroup">
                    <fui-column formGroupName="memberLoyalty">
                        <wbo-date-edit-control formControlName="newExpiry"
                                               [(ngModel)]="model.data.memberLoyalty.newExpiry">
                        </wbo-date-edit-control>
                    </fui-column>
                    <fui-column formGroupName="memberLoyalty">
                        <wbo-numeric-edit-control formControlName="daysToExtendExpiryBy"
                                                  [(ngModel)]="model.data.memberLoyalty.daysToExtendExpiryBy">
                        </wbo-numeric-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.containers', formControlNames: 'containers'}">
        <fui-rows>
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.containers" [editable]="false" [removable]="true"
                                   [entityPath]="'containers'" [reorderable]="true">
                        <wbo-edit-link-column field="name" [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                        <wbo-numeric-column [format]="'1.2-2'" field="weight">
                        </wbo-numeric-column>
                        <wbo-edit-grid-add-row [identifierField]="'containerId'">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-product-container-single-select-edit-control>
                                </wbo-product-container-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search
                                    [searchComponent]="ProductContainerSearchPageComponent"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [editComponent]="ProductContainerEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-line.edit.formation.recipeCard', formControlNames: ['productLineRecipeCard.recipeText', 'productLineRecipeCard.recipeImage']}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <div class="download-recipe-card-button">
                    <fui-commands [title]="'wbo.product-line.edit.actions.downloadRecipeCard'">
                        <fui-command [title]="'wbo.product-line.edit.actions.downloadRecipeCard'"
                                     (clicked$)="downloadRecipeCard()"></fui-command>
                    </fui-commands>
                </div>
            </fui-row>
            <fui-row formGroupName="productLineRecipeCard">
                <fui-two-columns>
                    <fui-column>
                        <wbo-image-edit-control formControlName="recipeImage"
                                                [(ngModel)]="model.data.productLineRecipeCard.recipeImage">
                        </wbo-image-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row formGroupName="productLineRecipeCard">
                <fui-column>
                    <wbo-textarea-edit-control formControlName="recipeText"
                                               [(ngModel)]="model.data.productLineRecipeCard.recipeText">
                    </wbo-textarea-edit-control>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
